/**
 * WordPress dependencies.
 */
import { __experimentalFontFamilyControl as FontFamilyControl } from '@wordpress/block-editor';

/**
 * Exteranl dependencies.
 */
import { isEmpty, find } from 'lodash';
import Select from 'react-select';

const GutenifyFontFamilyControl = ( {
	value = '',
	onChange,
	fontFamilies,
	...props
} ) => {
	// const globalStyle = useSelect( ( select ) => {
	// 	return select( coreStore ).__experimentalGetCurrentThemeBaseGlobalStyles();
	// }, [] );

	let blockLevelFontFamilies = [];

	// if ( has( globalStyle, `settings.typography.fontFamilies.theme` ) ) {
	// 	blockLevelFontFamilies = globalStyle.settings.typography.fontFamilies.theme;
	// }

	if ( window?._gutenify?.font_families ) {
		blockLevelFontFamilies = [ ...blockLevelFontFamilies, ...window._gutenify.font_families ];
	}

	const getTypographySlug = ( fontFamilySlug ) => {
		let name = fontFamilySlug;
		const presetFont = blockLevelFontFamilies.filter( ( themeFont ) => themeFont.slug === fontFamilySlug );
		if ( ! isEmpty( presetFont ) ) {
			name = presetFont[ 0 ].fontFamily;
		}

		return name;
	};

	if ( ! fontFamilies ) {
		fontFamilies = blockLevelFontFamilies;
	}

	const val = getTypographySlug( value );

	let options = [];
	let selectedFont = {};
	if ( window?._gutenify?.font_families ) {
		options = window._gutenify.font_families.map( ( font ) => {
			selectedFont = value === font.slug ? {
				value: font.slug,
				label: font.name,
			} : selectedFont;
			return {
				value: font.slug,
				label: font.name,
			};
		} );
	}

	// console.log( value );

	return <>
		{/* <FontFamilyControl
			value={ val }
			fontFamilies={ fontFamilies }
			onChange={ ( newValue ) => {
				const predefinedFontFamily = find(
					fontFamilies,
					( { fontFamily: f } ) => f === newValue
				);
				onChange( predefinedFontFamily ? predefinedFontFamily.slug : '' );
			} }
			{ ...props }
		/> */}
		<Select
			options={ options }
			value={ selectedFont }
			onChange={ ( font ) => {
				onChange( font.value );
			} }
		/>
	</>;
};

export default GutenifyFontFamilyControl;
